export default __webpack_public_path__ + "static/media/availability.44a77cbe.svg";